// Lights.js
import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';

export default class Lights {
  constructor(scene) {
    this.scene = scene;

    this.lights = []; // keep references to all lights
    this.helpers = {}; // keep references to helpers if needed

    this.keeperOffset = new THREE.Vector3(0, 5, 0);
    this.keeperTargetOffset = new THREE.Vector3(0, 4, 0);

    this.onEvents = this.onEvents.bind(this);
  }

  init(gui) {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents);
    this.events.addEventListener('GAME_EVENTS', this.onEvents);

    const dirLight = new THREE.DirectionalLight(0xffffff, 1);
    dirLight.position.set(5, 10, 5);
    dirLight.castShadow = true;

    dirLight.shadow.mapSize.width = 1024;
    dirLight.shadow.mapSize.height = 1024;
    dirLight.shadow.camera.near = 0.5;
    dirLight.shadow.camera.far = 25;
    dirLight.shadow.camera.left = -10;
    dirLight.shadow.camera.right = 10;
    dirLight.shadow.camera.top = 10;
    dirLight.shadow.camera.bottom = -10;

    this.scene.add(dirLight);

    // store reference
    this.lights.push(dirLight);
  }

  onEvents(data) {
    const msgType = data?.message?.event_type;
    switch (msgType) {
      case 'dispose':
        this.dispose();
        break;

      default:
        break;
    }
  }

  dispose() {
    // Remove all lights from scene
    this.lights.forEach((light) => {
      this.scene.remove(light);

      // If light has shadow maps, free them
      if (light.shadow && light.shadow.map) {
        light.shadow.map.dispose();
      }

      // Some lights have target objects
      if (light.target) {
        this.scene.remove(light.target);
      }
    });

    // Dispose helpers if any
    Object.values(this.helpers).forEach((helper) => {
      if (helper) {
        this.scene.remove(helper);
        if (helper.dispose) helper.dispose();
      }
    });

    // Clear references
    this.lights = [];
    this.helpers = {};

    if (this.events) {
      this.events.removeEventListener('GAMESCENE_EVENTS', this.onEvents);
      this.events.removeEventListener('GAME_EVENTS', this.onEvents);
    }
  }
}
